// react
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./../../assets/css/privacyModal.css";

const PrivacyModal = (props) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Modal
        show={props.showModal}
        onHide={props.hideModal}
        size="lg"
        scrollable={true}
        id="ItemEditModal"
        dialogClassName="modal-dialog-centered"
      >
        <Modal.Header onHide={props.hideModal} closeButton>
          {t("Privacy Policy")}
        </Modal.Header>
        <Modal.Body>
          <div
            className="privacyModal"
            style={{
              textAlign: "justify",
              marginLeft: "3em",
              marginRight: "3em",
            }}
          >
            <h3>{t("1. Privacy Policy at a glance")}</h3>
            <h4>{t("General information")}</h4>
            <p>
              {t(
                "The following information provides a simple overview of what happens to your personal data when you visit our website. Personal data is any data that can be used to identify you personally. For detailed information on the subject of privacy policy, please refer to our privacy policy declaration listed below this text."
              )}
            </p>
            <h4>{t("Data collection on our website")}</h4>
            <h5>
              {t("Who is responsible for data collection on this website?")}
            </h5>
            <p>
              {t(
                "Data processing on this website is carried out by the website operator. You can find the operator's contact details in the legal notice of this website."
              )}
            </p>
            <h5>{t("How do we collect your data?")}</h5>
            <p>
              {t(
                "On the one hand, your data is collected when you provide it to us. This may, for example, be data that you enter in a contact form. Other data is collected automatically by our IT systems when you visit the website. This is primarily technical data (e.g. internet browser, operating system or time of page view). This data is collected automatically as soon as you enter our website."
              )}
            </p>
            <h5>{t("What do we use your data for?")}</h5>
            <p>
              {t(
                "Some of the data is collected to ensure that the website is provided without errors. Other data can be used to analyze your user behavior."
              )}
            </p>
            <h5>{t("What rights do you have with regard to your data?")}</h5>
            <p>
              {t(
                "You have the right to receive information about the origin, recipient and purpose of your stored personal data free of charge at any time. You also have the right to request the correction, blocking or deletion of this data. You can contact us at any time at the address given in the legal notice if you have further questions on the subject of privacy policy. You also have the right to lodge a complaint with the competent supervisory authority."
              )}
            </p>
            <h5>{t("Analysis tools and tools from third-party providers")}</h5>
            <p>
              {t(
                "When you visit our website, your surfing behavior may be statistically evaluated. This is primarily done using cookies and so-called analysis programs. The analysis of your surfing behavior is usually anonymous; the surfing behavior cannot be traced back to you. You can object to this analysis or prevent it by not using certain tools. Detailed information on this can be found in the following privacy policy."
              )}
              <br />
              {t(
                "You can object to this analysis. We will inform you about the objection options in this privacy policy."
              )}
            </p>
            <h3>{t("2. general notes and mandatory information")}</h3>
            <h4>{t("Note on the responsible body")}</h4>
            <br />
            <p>
              {t(
                "The controller responsible for data processing on this website is"
              )}
              <br />
              <br />
              {t("Line Up Handels GmbH")}
              <br />
              {t("Tomphecke 42")}
              <br />
              {t("41169 Mönchengladbach")}
              <br />
              <br />
              {t(
                "The controller is the natural or legal person who alone or jointly with others determines the purposes and means of the processing of personal data (e.g. names, e-mail addresses, etc.)."
              )}
            </p>
            <h4>{t("Withdrawal of your consent to data processing")}</h4>
            <p>
              {t(
                "Many data processing operations are only possible with your express consent. You can withdraw your consent at any time. All you need to do is send us an informal e-mail. The legality of the data processing carried out until the revocation remains unaffected by the revocation."
              )}
            </p>
            <h4>
              {t(
                "Right to lodge a complaint with the competent supervisory authority"
              )}
            </h4>
            <p>
              {t(
                "In the event of breaches of privacy policy law, the data subject has the right to lodge a complaint with the competent supervisory authority. The competent supervisory authority for privacy policy issues is the state privacy policy officer of the federal state in which our company is based. A list of privacy policy officers and their contact details can be found at the following link:"
              )}
              <br />
              <a href="https://www.bfdi.bund.de/DE/Service/Anschriften/anschriften_table.html">
                {t("www.bfdi.bund.de/.")}
              </a>
            </p>
            <h4>{t("Right to data portability")}</h4>
            <p>
              {t(
                "You have the right to have data that we process automatically on the basis of your consent or in fulfillment of a contract handed over to you or to a third party in a common, machine-readable format. If you request the direct transfer of the data to another controller, this will only take place if it is technically feasible."
              )}
            </p>
            <h4>{t("SSL or TLS encryption")}</h4>
            <p>
              {t(
                "This site uses SSL or TLS encryption for security reasons and to protect the transmission of confidential content, such as orders or inquiries that you send to us as the site operator. You can recognize an encrypted connection by the fact that the address line of the browser changes from “http://” to “https://” and by the lock symbol in your browser line. If SSL or TLS encryption is activated, the data you transmit to us cannot be read by third parties."
              )}
            </p>
            <h3>{t("3. data collection on our website")}</h3>
            <h4> {t("Cookies")} </h4>
            <p>
              {t(
                "Some of the Internet pages use so-called cookies. Cookies do not damage your computer and do not contain viruses. Cookies are used to make our website more user-friendly, effective and secure. Cookies are small text files that are stored on your computer and saved by your browser."
              )}
              <br />
              {t(
                "Most of the cookies we use are so-called “session cookies”. They are automatically deleted at the end of your visit. Other cookies remain stored on your end device until you delete them. These cookies enable us to recognize your browser on your next visit. You can set your browser so that you are informed about the setting of cookies and only allow cookies in individual cases, exclude the acceptance of cookies for certain cases or in general and activate the automatic deletion of cookies when closing the browser. If cookies are deactivated, the functionality of this website may be restricted. Cookies that are required to carry out the electronic communication process or to provide certain functions you wish to use (e.g. shopping cart function) are stored on the basis of Art. 6 para. 1 lit. f GDPR. The website operator has a legitimate interest in the storage of cookies for the technically error-free and optimized provision of its services. Insofar as other cookies (e.g. cookies to analyze your surfing behavior) are stored, these are treated separately in this privacy policy."
              )}
              <br />
              {t("You can change your settings ")}
              <a href="">{t("here")}</a>
              {t(" at any time.")}
            </p>
            <h4>{t("Server log files")}</h4>
            <p>
              {t(
                "The provider of the pages automatically collects and stores information in so-called server log files, which your browser automatically transmits to us. These are"
              )}
            </p>
            <b>
              <ul>
                <li>{t("Browser type and browser version")}</li>
                <li>{t("Operating system used")}</li>
                <li>{t("Referrer URL")}</li>
                <li>{t("Host name of the accessing computer")}</li>
                <li>{t("Time of the server request")}</li>
                <li>{t("IP address")}</li>
              </ul>
            </b>
            <p>
              {t("This data is not merged with other data sources.")}
              <br />
              {t(
                "The basis for data processing is Art. 6 para. 1 lit. b GDPR, which permits the processing of data for the fulfillment of a contract or pre-contractual measures."
              )}
            </p>
            <h4>{t("Storage of the IP address")}</h4>
            <p>
              {t(
                "Our comment function stores the IP addresses of users who post comments. As we do not check comments on our site before they are activated, we need this data in order to be able to take action against the author in the event of legal violations such as insults or propaganda."
              )}
            </p>
            <h4>{t("Legal basis")}</h4>
            <p>
              {t(
                "The comments are stored on the basis of your consent (Art. 6 para. 1 lit. a GDPR). You can revoke your consent at any time. All you need to do is send us an informal email. The legality of the data processing operations already carried out remains unaffected by the revocation."
              )}
            </p>
            <h4>
              {t(
                "Data transmission upon conclusion of a contract for services and digital content"
              )}
            </h4>
            <p>
              {t(
                "We only transfer personal data to third parties if this is necessary in the context of contract processing, for example to the credit institution responsible for processing payments."
              )}
              <br />
              {t(
                "Any further transmission of data will not take place or will only take place if you have expressly consented to the transmission. Your data will not be passed on to third parties without your express consent, for example for advertising purposes."
              )}
              <br />
              {t(
                "The basis for data processing is Art. 6 para. 1 lit. b GDPR, which permits the processing of data for the fulfillment of a contract or pre-contractual measures."
              )}
            </p>
            <h4>{t("Data processing when using the Line Up Dashboard")}</h4>
            <p>
              {t(
                "To use the functions of the Line Up Dashboard, you must register for an account and provide"
              )}
            </p>
            <b>
              <ul>
                <li>{t("a valid e-mail address and")}</li>
                <li>{t("a password")}</li>
              </ul>
            </b>
            <p>{t("You must also provide the following information:")}</p>
            <b>
              <ul>
                <li>{t("First name,")}</li>
                <li>{t("surname,")}</li>
                <li>{t("company name.")}</li>
              </ul>
            </b>
            <p>
              {t(
                "This data is required to set up an account for you so that you can use the functions of the Line Up Dashboard. The processing of the data is therefore based on Art. 6 para. 1 lit. b GDPR."
              )}
              <br />
              {t(
                "You can voluntarily provide further information at a later date (hereinafter referred to as “voluntary information”). This may include, for example "
              )}
              <br />
            </p>
            <b>
              <ul>
                <li>{t("Your position,")}</li>
                <li>
                  {t("information about your company (company name, address),")}
                </li>
                <li>
                  {t(
                    "and the e-mail notifications you wish to receive (new order, status change, document upload). "
                  )}
                </li>
              </ul>
            </b>
            <p>
              {t(
                "can be. You can change or delete your voluntary information at any time. The legal basis for the collection and processing of your voluntarily provided data is also Art. 6 para. 1 lit. b GDPR."
              )}
            </p>
            <p>
              {t(
                "Further data assigned to your account may result from the Line Up Dashboard functions you use and may also be obtained from third-party providers involved in the supply chain (e.g. shipping service providers, manufacturers). When you submit a request, the data you enter about the item (e.g. title, quantity, item number, target price, weight, material) and the respective request (e.g. reference, comment, delivery date, delivery conditions, delivery and billing address) are processed. If you subsequently place a binding order, we process the data to process and fulfill your order. Here, too, the processing is carried out on the legal basis of Art. 6 para. 1 lit. b GDPR for the preparation and fulfillment of the contract concluded with you, alternatively - if the contract is concluded with your company - for the protection of legitimate interests, Art. 6 para. 1 lit. f GDPR, whereby our interests in the preparation and fulfillment of the contract prevail."
              )}
            </p>
            <h3>{t("4. analysis tools and advertising")}</h3>
            <h4>{t("Google Analytics")}</h4>
            <p>
              {t(
                "We use Google Analytics, a web analysis service of Google Ireland Limited (Gordon House Barrow Street, Dublin 4; hereinafter “Google”), for the purpose of designing and continuously optimizing our pages to meet your needs. The legal basis for this processing is your consent, Art. 6 para. 1 sentence 1 lit. a GDPR.."
              )}
              <br />
              {t(
                "In this context, pseudonymized user profiles are created and cookies (see section 3) are used. The information generated by the cookie about your use of this website such as"
              )}
            </p>
            <b>
              <ul>
                <li>{t("Browser type/version,")}</li>
                <li>{t("Operating system used,")}</li>
                <li>{t("Referrer URL (the previously visited page),")}</li>
                <li>
                  {t("Host name of the accessing computer (IP address),")}
                </li>
                <li>{t("time of the server request,")}</li>
              </ul>
            </b>
            <p>
              {t(
                "are transmitted to a Google server and stored there. The information is used to evaluate the use of the website, to compile reports on website activity and to provide other services relating to website activity and internet usage for the purposes of market research and the needs-based design of this website. This information may also be transferred to third parties if this is required by law or if third parties process this data on our behalf. Under no circumstances will your IP address be merged with other Google data. The IP addresses are anonymized so that they cannot be assigned (IP masking)."
              )}
            </p>
            <h4>{t("IP anonymization")}</h4>
            <p>
              {t(
                "We have activated the IP anonymization function on this website. This means that your IP address will be shortened by Google within member states of the European Union or in other contracting states of the Agreement on the European Economic Area before being transmitted to the USA. Only in exceptional cases will the full IP address be transmitted to a Google server in the USA and shortened there. On behalf of the operator of this website, Google will use this information to evaluate your use of the website, to compile reports on website activity and to provide other services relating to website activity and internet usage to the website operator. The IP address transmitted by your browser as part of Google Analytics will not be merged with other Google data."
              )}
            </p>
            <h4>{t("Browser plugin")}</h4>
            <p>
              {t(
                "You may refuse the use of cookies by selecting the appropriate settings on your browser, however please note that if you do this you may not be able to use the full functionality of this website. You can also prevent Google from collecting the data generated by the cookie and relating to your use of the website (including your IP address) and from processing this data by Google by downloading and installing the browser plug-in available at the following link:"
              )}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://tools.google.com/dlpage/gaoptout?hl=de."
              >
                {t("https://tools.google.com/dlpage/gaoptout?hl=de.")}
              </a>
            </p>
            <h4>{t("Objection to data collection")}</h4>
            <p>
              {t(
                "You can prevent the collection of your data by Google Analytics by clicking on the following link. An opt-out cookie will be set to prevent your data from being collected on future visits to this website:"
              )}
              <Button variant="link" style={{ boxShadow: "none" }}>
                {t("Deactivate Google Analytics.")}
              </Button>
              <br />
              {t(
                "You can find more information on how Google Analytics handles user data in Google's privacy policy:"
              )}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://support.google.com/analytics/answer/6004245?hl=de"
              >
                {t("here")}
              </a>
            </p>
            <h4>{t("Order data processing")}</h4>
            <p>
              {t(
                "We have concluded a contract with Google for commissioned data processing and fully implement the strict requirements of the German privacy policy authorities when using Google Analytics."
              )}
            </p>
            <h4>{t("Demographic characteristics in Google Analytics")}</h4>
            <p>
              {t(
                "This website uses the “demographic features” function of Google Analytics. This allows reports to be created that contain statements about the age, gender and interests of site visitors. This data comes from interest-based advertising from Google and visitor data from third-party providers. This data cannot be assigned to a specific person. You can deactivate this function at any time via the ad settings in your Google account or generally prohibit the collection of your data by Google Analytics as described in the section “Objection to data collection”."
              )}
            </p>
            <h4>{t("Hotjar")}</h4>
            <p>
              {t(
                "We use Hotjar to better understand the needs of our users and to optimize the offer and experience on this website. Hotjar's technology gives us a better understanding of our users' experiences (e.g. how much time users spend on which pages, which links they click on, what they like and dislike, etc.) and this helps us to tailor our offering to our users' feedback. Hotjar works with cookies and other technologies to collect data about the behavior of our users and their end devices, in particular the IP address of the device (is only recorded and stored in anonymized form during your website use), screen size, device type (unique device identifiers), information about the browser used, location (country only), preferred language for displaying our website. Hotjar stores this information on our behalf in a pseudonymized user profile. Hotjar is contractually prohibited from selling the data collected on our behalf."
              )}
              <br />
              {t("For more information, see the 'about Hotjar' section on")}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://help.hotjar.com/hc/en-us/sections/115003204947"
              >
                {t("Hotjar's help page.")}
              </a>
            </p>
            <h4>{t("Hubspot ")}</h4>
            <p>
              {t(
                "We collect personal data when you visit our website. We use the Hubspot services listed below from Hubspot Inc, Cambridge, Massachusetts, US. Hubspot (with a branch in Ireland - Hubspot European Headquarters, Ground Floor, Two Dockland Central, Guild Street, Dublin 1, Ireland) offers marketing automation software that can be used to operate marketing services such as content creation, SEO, lead management, email marketing and web analytics. We use the following Hubspot services:"
              )}
            </p>
            <ul>
              <li>
                <b>{t("Hubspot API: ")}</b>
                {t(
                  "we use Hubspot API to use other Hubspot services. The IP address is transmitted to Hubspot."
                )}
              </li>
              <li>
                <b>{t("Hubspot Pixel: ")}</b>
                {t(
                  "We use Hubspot Pixel to group our website visitors into so-called Custom Audiences, to determine and optimize conversion rates and to optimize our online offering."
                )}
              </li>
              <li>
                <b>{t("Hubspot Analytics: ")}</b>
                {t(
                  "We use Hubspot Analytics to analyze our online presence. This includes, among other things, visits to the website and the time spent on a page, which we present in reports to evaluate performance."
                )}
              </li>
              <li>
                <b>{t("Hubspot Forms: ")}</b>
                {t(
                  "We use Hubspot Forms to use and store the data inserted in forms, e.g. in contact forms for making contact. The data entered is stored in our CRM (Custom Relationship Management) system."
                )}
              </li>
            </ul>
            <p>
              {t("Further information on how Hubspot works can be found in ")}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://legal.hubspot.com/de/privacy-policy"
              >
                {t("Hubspot's privacy policy.")}
              </a>
              <br />
              {t(
                "The data processing is based on your consent through our cookie banner in accordance with Art. 6 para. 1 lit. a GDPR, provided that you have given your consent."
              )}
              <br />
              {t(
                "We process your data with the help of Hubspot Forms for the purpose of processing your contact request and the associated processing as well as with the help of Hubspot Analytics and the Hubspot Pixel for the purpose of optimizing our website and for marketing purposes on the basis of your consent in accordance with Art. 6 Para. 1 lit. a. GDPR. The use of Hubspot Forms and Hubspot API is subject to our legitimate interest in accordance with Art. 6 para. 1 lit. f GDPR, i.e. our interest in optimizing our online offer as well as the website and the associated marketing measures."
              )}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={props.hideModal}>
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default PrivacyModal;
